import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import BounceLoader from 'react-spinners/BounceLoader';

const styles = (theme) => ({
  spinner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'fixed',
    width: '100%',
    height: '100%',
    top: 0,
    lef: 0,
    zIndex: 2500,
    cursor: 'pointer',
    backgroundColor: 'rgba(0,0,0,0.5)',
  },
});

const AppLoading = (props) => {
  const { classes, appLoading } = props;
  return appLoading ? (
    <div className={classes.spinner}>
      <BounceLoader
        sizeUnit={'px'}
        size={30}
        color={'#123abc'}
        loading={appLoading}
      />
    </div>
  ) : null;
};

AppLoading.propTypes = {
  classes: PropTypes.object.isRequired,
  show: PropTypes.bool,
};

export default withStyles(styles, { withTheme: true })(AppLoading);
